import { Column, Entity, PrimaryColumn } from "typeorm"

@Entity()
export class RouterDetails {
  
  @PrimaryColumn()
  imei?: string

  @Column({nullable : true})
	iccid?: string

  @Column({nullable : true})
	clientId?: number

  @Column({nullable : true})
	ipAddress?: string
  
  @Column({ type: "double", nullable: true })
	latitude?: number

	@Column({ type: "double", nullable: true })
	longitude?: number

  @Column({nullable : true})
	signalDbm?: string

  @Column({nullable : true})
  plmn?: string

  @Column({nullable : true})
  lac?: string

  @Column({type:'datetime', nullable : true, default: null})
	lastCallback?: Date

}